import { useState } from "react";
import PropTypes from "prop-types";
import { Button, CircularProgress } from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import toast from "react-hot-toast";
import { sessionApi } from "../../../api/sessionApi";

/**
 * Bouton « Inscription FIF-PL » de la fiche session.
 *
 * Produit le classeur d'inscription collective attendu par le portail FIF-PL :
 * une ligne par apprenant au financeur FIFPL-PCC, les dix-huit colonnes
 * imposées. L'affichage du bouton est décidé par l'appelant, qui sait si la
 * session compte au moins un apprenant à ce financeur.
 *
 * Les apprenants dont la fiche est incomplète figurent quand même dans le
 * fichier, case vide : le message d'après-téléchargement les nomme, avec ce
 * qui leur manque, pour que ce soit corrigé avant le dépôt.
 */
const SessionFifplCollectiveButton = ({ sessionId, sx, disabled }) => {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const data = await sessionApi.downloadFifplCollective(
        sessionId,
        localStorage.getItem("accessToken")
      );

      const count = data.count || 0;
      toast.success(
        `Fichier FIF-PL téléchargé — ${count} inscription${count > 1 ? "s" : ""} !`
      );

      // Fiches à compléter avant dépôt : on nomme les apprenants et ce qui
      // manque, plutôt qu'un « certaines données sont absentes » inutile.
      if (data.incomplete && data.incomplete.length > 0) {
        const details = data.incomplete
          .map((l) => `${l.name} (${l.missing.join(", ")})`)
          .join(" · ");
        toast.error(
          `À compléter avant le dépôt sur le portail FIF-PL — ${details}`,
          { duration: 12000 }
        );
      }
    } catch (err) {
      console.error(err);
      toast.error(
        err.message || "Une erreur est survenue lors de la génération du fichier FIF-PL !"
      );
    }
    setDownloading(false);
  };

  return (
    <Button
      onClick={handleDownload}
      disabled={disabled || downloading}
      startIcon={
        downloading ? (
          <CircularProgress size={16} color="inherit" />
        ) : (
          <DownloadOutlinedIcon />
        )
      }
      sx={sx}
    >
      Inscription FIF-PL
    </Button>
  );
};

SessionFifplCollectiveButton.propTypes = {
  sessionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  sx: PropTypes.object,
  disabled: PropTypes.bool,
};

SessionFifplCollectiveButton.defaultProps = {
  sx: {},
  disabled: false,
};

export default SessionFifplCollectiveButton;
